import React from 'react';

function ChatBubble({
    text,
    onClick,
    disabled
}) {

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={` ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-[1.02] hover:shadow-lg'} w-full text-white bg-gray-800/80 hover:bg-gray-700/90 border border-gray-600 backdrop-blur-sm focus:ring-4 focus:outline-none focus:ring-pink-500/50 font-semibold rounded-xl text-base px-6 py-4 text-center mb-3 transition-all duration-200 shadow-md`}
        >
            {text}
        </button>
    );
}

export default ChatBubble;